import React, { useEffect } from "react";
import "./Tabs.css";
import $ from "jquery";
const tabsData = [
  {
    id: "one",
    topicName: "Conjunctions",
    subTopic: [
      {
        subName: "Use: Coordinate Conjunctions",
        value1: "5%",
        value2: "50%",
      },
      {
        subName: "Identify: Coordinate Conjunctions",
        value1: "4%",
        value2: "65%",
      },
      {
        subName: "Identify: Subordinating Conjunctions",
        value1: "15%",
        value2: "65%",
      },
      {
        subName: "Use: Correct Pair of Correlative",
        value1: "25%",
        value2: "65%",
      },
      {
        subName: "Fill in the Missing Correlative Conjunction",
        value1: "20%",
        value2: "65%",
      },
    ],
  },
  {
    id: "two",
    topicName: "Word relationship and usage",
    subTopic: [
      {
        subName: "Use: Coordinate Conjunctions",
        value1: "5%",
        value2: "50%",
      },
      {
        subName: "Identify: Coordinate Conjunctions",
        value1: "9%",
        value2: "65%",
      },
    ],
  },
  {
    id: "three",
    topicName: "Descriptive and figurative language",
    subTopic: [
      {
        subName: "Use: Coordinate Conjunctions",
        value1: "5%",
        value2: "50%",
      },
      {
        subName: "Identify: Coordinate Conjunctions",
        value1: "9%",
        value2: "65%",
      },
    ],
  },
];
const Tabs = (props) => {
  useEffect(() => {
    $(".collapse")
      .on("shown.bs.collapse", function () {
        $(this)
          .parent()
          .find(".fa-plus")
          .removeClass("fa-plus")
          .addClass("fa-minus");
      })

      .on("hidden.bs.collapse", function () {
        $(this)
          .parent()
          .find(".fa-minus")
          .removeClass("fa-minus")
          .addClass("fa-plus");
      });
  });
  return (
    <div className="row">
      <div className="col-md-8">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              data-toggle="tab"
              href="#tabs-1"
              role="tab"
            >
              Activity
          </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#tabs-2" role="tab">
              History
          </a>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane active" id="tabs-1" role="tabpanel">
            <div id="accordion2" class="myaccordion">
              {tabsData.map((item, index) => (
                <div class="card" key={index}>
                  <div class="card-header" id="headingOne">
                    <h2 class="mb-0">
                      <div
                        className="row"
                        class="d-flex align-items-center justify-content-between btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target={`#One${item.id}`}
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <div className="col-md-6 text-left">
                          <label style={{ fontSize: 17 }}>{item.topicName}</label>
                        </div>
                        <div className="col-md-4">
                          <label className="mr-2">Average</label>
                        </div>
                        <div className="col-md-2">
                          <span class="fa-stack fa-sm">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-plus fa-stack-1x fa-inverse"></i>
                          </span>
                        </div>
                      </div>
                    </h2>
                  </div>
                  <div
                    id={`One${item.id}`}
                    class="collapse"
                    aria-labelledby="headingOne"
                    data-parent="#accordion2"
                  >
                    <div class="card-body" style={{ backgroundColor: "#F7F6F6" }}>
                      <ol>
                        {item.subTopic.map((itemi, indexi) => (
                          <React.Fragment>
                            <div className="row">
                              <div className="col-md-7">
                                <li>
                                  <label
                                    className="hoverColorChange"
                                    onMouseOver={props.onHoverChange}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {itemi.subName}
                                  </label>
                                </li>
                              </div>
                              <div className="col-md-5">
                                <label className="font-weight-bold">
                                  {itemi.value1}
                                </label>
                              </div>
                            </div>
                            <hr />
                          </React.Fragment>
                        ))}
                      </ol>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div class="tab-pane" id="tabs-2" role="tabpanel">
            {/* <div className="row">
            <div className="col-md-12 mt-2">
              <div class="card">
                <div class="card-body">
                  <div id="accordion">
                    {tabsData.map((item, index) => (
                      <React.Fragment>
                        <div className="tabsActive"></div>
                        <h4
                          key={index}
                          data-toggle="collapse"
                          data-target={`#One${item.id}`}
                          className="collapsed"
                        >
                          {item.topicName}
                        </h4>
                        <hr />
                        <div
                          id={`One${item.id}`}
                          className="collapse p-3"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          {item.subTopic.map((itemi, indexi) => (
                            <React.Fragment>
                              <div className="row">
                                <div className="col-md-8">
                                  <label onMouseOver={props.onHoverChange}>
                                    {indexi + 1}. {itemi.subName}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  <label className="mr-2 font-weight-bold">
                                    {itemi.value1}
                                  </label>
                                  <label className="mr-2 font-weight-bold">
                                    {itemi.value2}
                                  </label>
                                </div>
                              </div>
                              <hr />
                            </React.Fragment>
                          ))}
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tabs;
